import { TOC } from '@/lib/book';

interface TocPanelProps {
  open: boolean;
  currentPage: number;
  onClose: () => void;
  onSelect: (page: number) => void;
}

export default function TocPanel({ open, currentPage, onClose, onSelect }: TocPanelProps) {
  return (
    <div className={`fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`} aria-hidden={!open}>
      <button
        type="button"
        aria-label="차례 닫기"
        onClick={onClose}
        className={`absolute inset-0 bg-foreground-950/60 transition-opacity ${
          open ? 'opacity-100' : 'opacity-0'
        }`}
      ></button>

      <aside
        className={`absolute left-0 top-0 flex h-full w-[86%] max-w-sm flex-col bg-background-50 transition-transform duration-300 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
        role="dialog"
        aria-label="차례"
      >
        <div className="flex items-center justify-between border-b border-background-300 px-5 py-4">
          <h2 className="font-heading text-xl font-bold text-foreground-950">차례</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="차례 닫기"
            className="flex h-11 w-11 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-200"
          >
            <i className="ri-close-line text-2xl" aria-hidden="true"></i>
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-3">
          {TOC.map((item) => {
            const active = currentPage === item.page;
            if (item.level === 1) {
              return (
                <button
                  key={`${item.page}-${item.label}`}
                  type="button"
                  onClick={() => onSelect(item.page)}
                  className={`flex w-full items-center justify-between gap-3 rounded-md px-4 py-3 text-left transition-colors ${
                    active ? 'bg-primary-800 text-background-50' : 'hover:bg-background-200'
                  }`}
                >
                  <span className={`font-heading text-base font-bold ${active ? 'text-background-50' : 'text-foreground-950'}`}>
                    {item.label}
                  </span>
                  <span className={`font-label text-sm ${active ? 'text-accent-300' : 'text-accent-700'}`}>
                    {item.page}
                  </span>
                </button>
              );
            }
            return (
              <button
                key={`${item.page}-${item.label}`}
                type="button"
                onClick={() => onSelect(item.page)}
                className={`flex w-full items-center justify-between gap-3 rounded-md py-2.5 pl-8 pr-4 text-left transition-colors ${
                  active ? 'bg-primary-800 text-background-50' : 'hover:bg-background-200'
                }`}
              >
                <span className={`text-sm ${active ? 'text-background-50' : 'text-foreground-700'}`}>{item.label}</span>
                <span className={`font-label text-sm ${active ? 'text-accent-300' : 'text-secondary-500'}`}>
                  {item.page}
                </span>
              </button>
            );
          })}
        </nav>
      </aside>
    </div>
  );
}